import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_RATE_DOLLAR = "getRateDollar"; 
export const GET_WALLET_SUMMERY = "getWalletSummery";

//mutation types
export const SET_RATE_DOLLAR = "setRateDollar";
export const SET_WALLET_SUMMERY = "setWalletSummery";


export default {
    state: {
        listExchange:[],
        walletSummery:{},
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedListExchange(state) {
            return state.listExchange;
        },
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedWalletSummery(state) {
            return state.walletSummery;
        },
    },
    actions: {
        /**
         * Set the create countMyPurcents
         * @param state
         * @param payload
         */
         [GET_RATE_DOLLAR](context,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .getData('exchange')
                .then((response) => {
                    context.commit(SET_RATE_DOLLAR,response.result)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
        /**
         * Set the create listPusrcent
         * @param state
         * @param payload
         */
        [GET_WALLET_SUMMERY](context,payload) {
            return new Promise((resolve, reject) => {
            httpHelper
                .getData(`walletSummery/${payload}`)
                .then((response) => {
                    context.commit(SET_WALLET_SUMMERY,response.result)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
        
    },
    mutations: {
        [SET_RATE_DOLLAR](state, payload) {
            state.listExchange = [...payload];
        },
        [SET_WALLET_SUMMERY](state, payload) {
            state.walletSummery = payload;
        },
    }
};